export default "__VITE_ASSET__97dd9a8e__"